import { render, staticRenderFns } from "./RoleMenuAuth.vue?vue&type=template&id=1f50a48b&scoped=true&"
import script from "./RoleMenuAuth.vue?vue&type=script&lang=js&"
export * from "./RoleMenuAuth.vue?vue&type=script&lang=js&"
import style0 from "./RoleMenuAuth.vue?vue&type=style&index=0&id=1f50a48b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f50a48b",
  null
  
)

export default component.exports